import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { commonActions } from "stores/common/commonActions";
import { DashboardAction } from "stores/DashboardStore/dashboardAction";

const mapStateToProps = (state) => {
  return {
    dashboardrevenueList: state.dashboard.dashboardrevenueList,
    cutomersdataList: state.dashboard.cutomersdataList,
    timeconsumeddataList: state.dashboard.timeconsumeddataList,
    powerconsumeddataList: state.dashboard.powerconsumeddataList,
    populartimesdataList: state.dashboard.populartimesdataList,
    dashboardrevenue: state.dashboard.dashboardrevenue,
    customerdata: state.dashboard.customerdata,
    timeconsumeddata: state.dashboard.timeconsumeddata,
    powerconsumeddata: state.dashboard.powerconsumeddata,
    populartimesdata: state.dashboard.populartimesdata,
    isLoadingdashboardrevenue: state.dashboard.dashboardrevenue.isLoading,
    isLoadingcustomerdata: state.dashboard.customerdata.isLoading,
    isLoadingtimeconsumeddata: state.dashboard.timeconsumeddata.isLoading,
    isLoadingpowerconsumeddata: state.dashboard.powerconsumeddata.isLoading,
    isLoadingpopulartimesdata: state.dashboard.populartimesdata.isLoading,
    VendorNameData: state.common.VendorNameData,
    vehicleMasterData: state.common.vehiclesMasterData,
    locationData: state.common.locationData,
    manufacturerData: state.common.manufacturerData,
    isLoading: state.bookingTable.bookingTable.isLoading,
    profile: state.login.userProfile,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getDashboardAction: DashboardAction.getdashboardrevenue,
      getcustomerAction: DashboardAction.getcustomer,
      gettimeAction: DashboardAction.gettimeconsumed,
      getpowerAction: DashboardAction.getpowerconsumed,
      getpopularAction: DashboardAction.getpopulartime,
      getVehiclesMasterAction: commonActions.getVehiclesMasterData,
      getLocationAction: commonActions.getLocationData,
      getManufacturerAction: commonActions.getManufacturerData,
      getVendorNameDataAction: commonActions.getVendorNameData,
    },
    dispatch
  );

const DashboardStore = (Container) =>
  connect(mapStateToProps, mapDispatchToProps)(Container);
export default DashboardStore;
